<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .topList-div {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 450px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .reportDiv-List {
    width: 100%;
    padding:20px;
    box-sizing: border-box;
    .top{
        display: flex;
        div{
            width: 15%;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #8F9BB3;
            &:last-child{
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #4182EB;
                letter-spacing: 1px;
            }
        }
      }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
     
      .list-left {
        width: 20%;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 210px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 60%;
        height: 260px;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 257px;
        }
      }
      .list-right2 {
        width: 20%;
        height: 180px;
        overflow: hidden;
        p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 20%;
            }
            span:nth-child(2) {
              display: block;
              width: 50%;
              display: flex;
              justify-content: flex-end;
              align-content: center;
            }
            span:nth-child(3) {
              display: block;
              width: 17px;
              height: 17px;
              background: #BB87F3;
            border-radius: 4px;
            }
          }
      }
    }
    .to-List{
        width: 100%;
        // height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        
    }
  }
}

.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title">广告位点击报表</div>

      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>2023.11.14~2023.11.2</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户访问 -->
        <div class="reportDiv-List">
            <div class="top">
                <div>个人中心</div>
                <div><span>1999</span></div>
              </div>
          <div class="list">
            <div class="list-left">
              
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
            <div class="list-right2">
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>点击总量</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>挚达APP点击量</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>支付宝小程序点击量</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>微信小程序点击量</span>
                <span></span>
              </p>
            </div>
          </div>
          <div class="to-List"><el-button type="primary" @click="toVisitor">数据列表</el-button></div>
        </div>
      </div>
      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>2023.11.14~2023.11.2</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户注册数 -->
        <div class="reportDiv-List">
            <div class="top">
                <div>购桩顶部</div></div>
                <div><span>1999</span></div>
              </div>
          <div class="list">
            <div class="list-left">
              
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
                <p>
                  <span>挚达APP点击量</span>
                  <span>1039</span>
                  <span>54.02%</span>
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="bindingTrend"></div>
            </div>
            <div class="list-right2">
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>点击总数</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>挚达APP点击数</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>支付宝小程序点击数</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>微信小程序点击数</span>
                <span></span>
              </p>
              <p>
                <span><el-checkbox v-model="checkbox1" ></el-checkbox></span>
                <span>微信小程序点击数</span>
                <span></span>
              </p>
            </div>
          </div>
          <div class="to-List"><el-button type="primary" @click="toRegistration">数据列表</el-button></div>
        </div>
      </div>

  </div>
</template>

<script>
import pageConfig from "./page-config";
// import dateUtil from "../../../utils/dateUtils";
import { EleResize } from "../../../../config/esresize";
import * as echarts from "echarts";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      daysChange: true,
      checkbox1:false,
      checkbox2:false,
      checkbox3:false,
      checkbox4:false,
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();
    },
    //选择系统日期时间
    handleDateChange(val) {
      this.daysChange = !this.daysChange;
    },
    toVisitor(){
      let _ = this;
      var url = _.$router.resolve({ name: "personalList", query: { id: '0' } });
      window.open(url.href, "_blank");
    },
    toRegistration(){
      let _ = this;
      var url = _.$router.resolve({ name: "purchasingList", query: { id: '0' } });
      window.open(url.href, "_blank");
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    // 注册趋势
    getRegistrationTrends() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f6eefd", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#dec8f5", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cfabf7", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: ["12-1", "12-2", "12-3", "12-4", "12-5", "12-6", "12-7"],
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: [550, 430, 324, 518, 635, 847, 360],
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#bc88f5", //改变折线点的颜色
                lineStyle: {
                  color: "#bc88f5", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 绑定趋势
    getBindingTrend() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("bindingTrend")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e0ecff", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#d1e5ff", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#3f8fff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: ["12-1", "12-2", "12-3", "12-4", "12-5", "12-6", "12-7"],
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: [550, 430, 324, 518, 635, 847, 360],
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#408fff", //改变折线点的颜色
                lineStyle: {
                  color: "#408fff", //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.init();
    this.getRegistrationTrends();
    this.getBindingTrend();
  },
};
</script>
